import { createContext, useContext } from 'react';

import { PresentationCoverSlideConfig } from '@/modules/slideEditor/coverSlide/CoverSlide.types';
import { COLORS } from '@/styles/tokens/colors';

// The slide owns branding; both preview and client footers use these values.
export const SlideFooterBrandingContext = createContext<
  Pick<PresentationCoverSlideConfig, 'footerColor' | 'useDarkLogo'> | undefined
>(undefined);

export function useSlideFooterBranding(): Pick<
  PresentationCoverSlideConfig,
  'footerColor' | 'useDarkLogo'
> {
  const branding = useContext(SlideFooterBrandingContext);
  // Only cover and divider slides pass a design, including an empty default.
  if (!branding) return {};

  return {
    ...branding,
    footerColor: branding.footerColor || COLORS.NEUTRAL_GRAY[700],
  };
}
